import React from "react";
import { useProductDispatch } from "../../stores/product/product.store";
import { gtag } from "../../stores/product/product.reducer";
import { OptionsInterface } from "../../interfaces/product/product.interface";

interface OptionProps {
    option: OptionsInterface;
}

export const Option: React.FC<OptionProps> = ({ option }) => {
    const dispatch = useProductDispatch();

    const click = () => {
        dispatch(gtag('mn_item_switch_params'));
    }

    return (
        <div className="mb-5">
            <p className="text-[14px] mb-3 font-medium">{ option.name }</p>
            <div className="flex flex-wrap gap-2">
                { option.values.map((value, i) =>
                    <a aria-label={`${ option.name } ${ value.value }`} onClick={ () => click() } href={ value.link } key={ i } className={ `${ value.current ? 'border-yellow' : 'border-white' } rounded-xl border-2 cursor-pointer bg-[#F7F8FA]` }>
                        { option.type === 'color' ? <div style={{ backgroundColor: value.value }} className={ `rounded-xl w-[36px] h-[36px]` } /> : <div className="text-[14px] font-semibold py-2 px-5 text-black">{ value.value }</div>}
                    </a>
                ) }
            </div>
        </div>
    )
}